import React, { useEffect, useState } from "react";
import "./loginPageStyle.scss";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { Controller, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { SocketState } from "../context/SocketProvider";
import { useDispatch } from "react-redux";
import { SET_MAIN_LOADER } from "../redux/loaderSlice";
import { SET_LOGIN_FORM_ERROR } from "../redux/errorMessageSlice";
// import {
//   FaUser,
//   FaLock,
//   FaSignInAlt,
//   FaChartBar,
//   FaDice,
// } from "react-icons/fa";

/* ================= VALIDATION ================= */

const schema = yup.object().shape({
  user_name: yup.string().required("Username required"),
  password: yup.string().required("Password required"),
});

const defaultValues = {
  user_name:
    JSON.parse(localStorage.getItem("creditionlsDetails"))?.user_name || "",
  password:
    JSON.parse(localStorage.getItem("creditionlsDetails"))?.password || "",
};

function LoginPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { socket } = SocketState();

  const [announcement, setAnnouncement] = useState(
    "🎉 Welcome to 7STAR LOTTO 🎉"
  );

  useEffect(() => {
    if (!socket) return;

    socket.emit("req", {
      en: "GET_ANNOUCEMENT",
      data: {},
    });

    const handleRes = (res) => {
      if (res?.en === "GET_ANNOUCEMENT") {
        setAnnouncement(
          res.data?.annoucements || "🎉 Welcome to 7STAR LOTTO 🎉"
        );
      }
    };

    socket.on("res", handleRes);

    return () => socket.off("res", handleRes);
  }, [socket]);

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues,
  });

  const onSubmit = ({ user_name, password }) => {
    dispatch(SET_LOGIN_FORM_ERROR(null));
    dispatch(SET_MAIN_LOADER(true));

    localStorage.setItem(
      "creditionlsDetails",
      JSON.stringify({ user_name, password })
    );

    socket?.emit("req", {
      en: "AppLunchDetails",
      data: {
        user_name,
        password,
      },
    });
  };

  return (
    <div className="login-page">
      {/* Announcement */}

      <div className="announcement-bar">
        <div className="announcement-text">{announcement}</div>
      </div>

      {/* Main */}

      <div className="login-container">
        {/* Left */}

        {/* Right */}

        <div className="right-panel">
          <div className="login-card">
            <h2><b>7STAR</b></h2>

            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="input-box">
                {/* <FaUser /> */}

                <Controller
                  control={control}
                  name="user_name"
                  render={({ field }) => (
                    <input {...field} placeholder="Username" />
                  )}
                />
              </div>

              <div className="input-box">
                {/* <FaLock /> */}

                <Controller
                  control={control}
                  name="password"
                  render={({ field }) => (
                    <input
                      {...field}
                      type="password"
                      placeholder="Password"
                    />
                  )}
                />
              </div>

              <button className="login-btn">
                {/* <FaSignInAlt /> */}
                Login
              </button>
            </form>

            <div className="result-buttons">
              <button onClick={() => navigate("/result")}>
                {/* <FaChartBar /> */}
                4D Chart
              </button>

              <button onClick={() => navigate("/resultTitli")}>
                {/* <FaDice /> */}
                Titli Result
              </button>

              <button onClick={() => navigate("/result3d")}>
                {/* <FaChartBar /> */}
                3D Result
              </button>

              <button onClick={() => navigate("/result2d")}>
                {/* <FaChartBar /> */}
                4D Result
              </button>

              <button
                className="full"
                onClick={() => navigate("/result1d")}
              >
                {/* <FaChartBar /> */}
                2D Result
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LoginPage;